import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store, The_Ability } from "./store";
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import vuetify from "@/plugins/vuetify";
// import "./registerServiceWorker";
// import VueAuth from '@d0whc3r/vue-auth-plugin';
// import axios from 'axios'
// import VueAxios from 'vue-axios';
import "@websanova/vue-auth";

// import VueI18n from 'vue-i18n'

// import VueSweetalert2 from "vue-sweetalert2";
// import "sweetalert2/dist/sweetalert2.min.css";

// import VueAuthenticate from 'vue-authenticate'

import i18n from "./i18n";

// let messages = require('../locales/pt_BR.js')
// Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'pt_BR', // set locale
//   messages
// })

// Vue.use(VueAxios, axios)
// Vue.axios.defaults.baseURL = 'http://192.168.0.155:3000';

// Vue.use(VueSweetalert2);
import "./plugins/sweet-alert2";
import "./plugins/vue-auth";

import './idb_dexie/idb_dexie.js'

import "./plugins/vue_leaflet";

import "./plugins/signature_pad";
import "./plugins/vue_papa_parse";
import "./plugins/v_calendar";
import "./plugins/actioncable_vue"

// import "./plugins/sentry";

// adding charts
//yarn add vue-chartjs chart.js chartjs-plugin-doughnutlabel chartjs-plugin-datalabels
// yarn add vue-browser-geolocation
import VueGeolocation from "vue-browser-geolocation";
Vue.use(VueGeolocation);

import VueMermaid from "vue-mermaid/src";
Vue.use(VueMermaid);

import CardLoadingTransparent from "./components/shared/CardLoadingTransparent";
import CardLoading from "./components/shared/CardLoading";
import DialogLoading from "./components/shared/DialogLoading";
import ChipMonthPickerMenu from "./components/shared/MonthPickerMenu.vue";
import SortFilterTable from './components/shared/SortFilterTable.vue';
import DatePicker from "./components/shared/DatePicker";

Vue.component("dialog-loading", DialogLoading);
Vue.component("card-loading", CardLoading);
Vue.component("card-loading-transparent", CardLoadingTransparent);
Vue.component("chip-month-picker-menu", ChipMonthPickerMenu);
Vue.component("sort-filter-table", SortFilterTable);
Vue.component("date-picker", DatePicker);

import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});

import { abilitiesPlugin } from "@casl/vue";
Vue.use(abilitiesPlugin, The_Ability);

import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);

Vue.config.productionTip = false;
// Vue.config.devtools = true

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

import excel from "vue-excel-export";
Vue.use(excel);

var SocialSharing = require("vue-social-sharing");
Vue.use(SocialSharing);

var filter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent.trim();
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);


import validations from "@/mixins/validations";
Vue.mixin(validations)

import { globalFunctions } from "./utils/global_functions.js";
Vue.prototype.$global_functions = globalFunctions;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  The_Ability,
  render: (h) => h(App),
}).$mount("#app");
